module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_vm._v("Applications")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.client.name))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id) + "/articles")
    }
  }, [_vm._v("Articles")])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v(_vm._s(this.$store.state.article.title))])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal
    },
    on: {
      "close": _vm.closeDeleteArticleModal
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v("Deleting article")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('span', {
    staticClass: "icon is-large has-text-danger"
  }, [_c('i', {
    staticClass: "fa fa-3x fa-exclamation-triangle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('p', [_vm._v("Are you sure you want to "), _c('strong', [_vm._v("delete")]), _vm._v(" this article?")]), _vm._v(" "), _c('p', [_vm._v("This action cannot be undone.")])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-danger",
    on: {
      "click": _vm.deleteItem
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.closeDeleteArticleModal
    }
  }, [_vm._v("Cancel")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-1"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v(_vm._s(this.$store.state.article.title))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Article ID:")]), _vm._v(" " + _vm._s(this.$store.state.article.id))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Location:")]), _vm._v(" " + _vm._s(this.$store.state.article.location))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Created at:")]), _vm._v(" " + _vm._s(this.$store.state.article.created_at))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Updated at:")]), _vm._v(" " + _vm._s(this.$store.state.article.updated_at))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button is-primary is-outlined",
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id) + "/articles/" + (this.$route.params.article_id) + "/edit")
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-pencil"
  })]), _vm._v(" "), _c('span', [_vm._v("Edit")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-danger is-outlined",
    on: {
      "click": _vm.openDeleteArticleModal
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Delete")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-1"
  }, [_c('article', {
    staticClass: "media"
  }, [(this.$store.state.article.cover) ? _c('figure', {
    staticClass: "media-left"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "image is-128x128"
  }, [_c('img', {
    attrs: {
      "src": (_vm.apiUrl + "/articles/covers/" + (this.$store.state.article.cover) + "?size=square")
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [(this.$store.state.article.content) ? _c('div', {
    staticClass: "content"
  }, [_vm._m(2), _vm._v(" "), _c('p', [_vm._v(_vm._s(this.$store.state.article.content))])]) : _c('div', {
    staticClass: "content"
  }, [_vm._m(3), _vm._v(" "), _c('p', [_vm._v(_vm._s(this.$store.state.article.link))])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Cover:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Content:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Link:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45f1ecf7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Articles/ArticleView.vue
// module id = 338
// module chunks = 1